import { render, staticRenderFns } from "./AudioNotification.vue?vue&type=template&id=2575c50d&"
import script from "./AudioNotification.vue?vue&type=script&lang=js&"
export * from "./AudioNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports